import React from "react";

import {sentimentColours} from "../../../style/styleConsts";

export function SentimentValue(props) {
    const backgroundColourMapping = {
        ...sentimentColours,
        "\u2014": "none"
    };
    const sentimentValue = props.sentiment ? props.sentiment.todayValue : "\u2014";
    const defaultStyle = {
        backgroundColor:backgroundColourMapping[sentimentValue],
        textAlign:"center",
        fontSize: "11px",
        width:16,
        height:16,
        lineHeight: "16px",
        display:"inline-block",
        verticalAlign: "9%"
    };
    const largeStyle = {
        fontSize: 18,
        width: 26,
        height: 26,
        lineHeight: "26px"
    };
    const style = {
        ...defaultStyle,
        ...(props.large ? largeStyle : {}),
        ...(sentimentValue !== "\u2014" ? {color:"white"} : {})
    };
    return <div className="t-value" style={style}>{sentimentValue}</div>
}

function withLeadingPlus(number) {
    if (number === 0) {
        return "±" + number;
    } else if (number > 0) {
        return "+" + number;
    }
    return number;
}

export function SentimentChange(props) {
    const colourMapping = {
        "9": sentimentColours[10],
        "8": sentimentColours[10],
        "7": sentimentColours[9],
        "6": sentimentColours[9],
        "5": sentimentColours[8],
        "4": sentimentColours[8],
        "3": sentimentColours[7],
        "2": sentimentColours[7],
        "1": sentimentColours[6],
        "0": sentimentColours[6],
        "-1": sentimentColours[5],
        "-2": sentimentColours[4],
        "-3": sentimentColours[4],
        "-4": sentimentColours[3],
        "-5": sentimentColours[3],
        "-6": sentimentColours[2],
        "-7": sentimentColours[2],
        "-8": sentimentColours[1],
        "-9": sentimentColours[1],
        "\u2014": "inherit"
    };
    const sentimentChange = (props.sentiment && props.sentiment.oneDayChange !== null) ? props.sentiment.oneDayChange : "\u2014";
    return <div className="t-change" style={{color:colourMapping[sentimentChange], display: "inline-block", ...props.style}}>{withLeadingPlus(sentimentChange)}</div>
}
